import React from "react";
import "./style.scss";
import { isMobile } from 'react-device-detect';
import { AnyAction } from "@reduxjs/toolkit";

export interface IEditComponent {
  informations?: any;
  label?: any;
  goToStep?: any;
  choixResiliation?: any;
}

const editIcone: string =
  require("../../../assets/edit.svg").default;

const EditComponent = ({ informations, label, goToStep, choixResiliation }: IEditComponent) => {




  return (
    <div className={`edit-component ${isMobile && "w-100"}`}>
      <div className="d-flex justify-content-between align-items-start pl-3">
        <div className="pe-5">{label && <p className="fw-bold">{label}</p>}</div>
        <div> <img
          src={editIcone}
          width={20}
          onClick={() => {
            goToStep()
          }}
        />
        </div>
      </div>
      <div className="row w-100">
        <div >{choixResiliation}</div>
        <div className="w-75">
          {Object.entries(informations).map((key: any) => (
            <div className="descriptionRecap" key={key[0]}>
              {((key[0] === 'dateNaissance' || key[0] === 'date') && key[1] !== null) ?
                (() => {
                  const parts = key[1].split('-'); // Car date est retuournee sous le format 'YYYY-MM-DD'
                  if (parts.length === 3) {
                    const year = parts[0];
                    const month = parts[1].padStart(2, '0');
                    const day = parts[2].padStart(2, '0');

                    return `${day}/${month}/${year}`;
                  }

                  return key[1];
                })()
                :
                key[1]}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EditComponent;
